import { SxProps, Theme } from "@mui/material/styles";

export const captainInfoContainer: SxProps<Theme> = (theme) => ({
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
});

export const captainHeader: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
};

export const captainImg: SxProps<Theme> = {
    height: "100px",
    borderRadius: "10px",
    border: "2px solid #fff",
};

export const captainInfoTitle: SxProps<Theme> = {
    fontWeight: "700",
    fontFamily: "HsvSlab",
};

export const captainInfoSubtitle: SxProps<Theme> = {
    fontFamily: "HsvSlab",
};

export const captainInfoText: SxProps<Theme> = {
    fontFamily: "HsvSans",
};
